// extracted by mini-css-extract-plugin
export var modal = "_ge-0";